<template lang="html">
    <BaseWidget>
        <template slot="title"
            ><i class="fas fa-star fa-1x pointer" :style="{ color: colors.color4 }"></i> {{ $t("dashboardModule.featureTitle") }}
        </template>
        <template slot="content-desktop">
            <div class="catalog-star-item">
                <div class="item-star" v-for="item in itemList" :key="item.id">
                    <router-link :to="'/' + item.type + '/' + item.id">
                        <div class="row">
                            <figure class="col-md-4"><img :src="getImgPath(item.figures.small, 'small')" /></figure>
                            <div class="col-md-8">
                                <h4 class="ff-medium uppercase">{{ item.terms.name[$t("trad")]["value"] }}</h4>
                                <p v-if="item.infosArticle.hasOwnProperty('client_ref1')">
                                    {{ item.infosArticle.client_ref1.componentProperty.value }}
                                </p>
                                <p v-if="item.infosArticle.hasOwnProperty('diam_ref1')">{{ item.infosArticle.diam_ref1.componentProperty.value }}</p>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </template>
        <template slot="content-mobile">
            <div class="catalog-star-item">
                <div class="item-star" v-for="item in itemList" :key="item.id">
                    <router-link :to="'/' + item.type + '/' + item.id">
                        <div class="row">
                            <figure class="col-md-4"><img :src="getImgPath(item.figures.small, 'small')" /></figure>
                            <div class="col-md-8">
                                <h4 class="ff-medium uppercase">{{ item.terms.name[$t("trad")]["value"] }}</h4>
                                <p v-if="item.infosArticle.hasOwnProperty('client_ref1')">
                                    {{ item.infosArticle.client_ref1.componentProperty.value }}
                                </p>
                                <p v-if="item.infosArticle.hasOwnProperty('diam_ref1')">{{ item.infosArticle.diam_ref1.componentProperty.value }}</p>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </template>
        <template slot="footer">
            <LinkButton :to="'/catalog?star=1'" :text="$t('dashboardModule.seeAllCat')" />
        </template>
    </BaseWidget>
</template>

<script lang="js">
import BaseWidget from "@/components/dashboard/BaseWidget";
import cacheService from "@/services/cache";
import LinkButton from "@/components/dashboard/elements/LinkButton";
import Globals from "@/components/globals";

export default {
    components: { LinkButton, BaseWidget },
    props: {
        itemList: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            colors: cacheService.getBrandColors()
        };
    },
    methods: {
        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + "/" + imgPath;
        },
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
.catalog-star-item {
    overflow-y: auto;
    max-height: 500px;
    & .item-star {
        border-bottom: 1px solid #e2e2e2;
        width: calc(50% - 30px);
        display: inline-block;
        height: 120px;
        margin: 15px;
        @media only screen and (max-width: 767px) {
            height: 230px;
        }
        & a {
            text-decoration: none;
        }
        & figure {
            padding: 0;
            @media only screen and (max-width: 767px) {
                text-align: center;
                margin-bottom: 10px;
            }
            & img {
                max-height: 100px;
            }
        }
        & h4 {
            @extend %primary-text;
            margin: 0;
        }
        & p {
            font-size: 12px;
            font-family: "oswald-regular", sans-serif;
            @extend %primary-text;
            margin: 5px 0;
            opacity: 0.7;
        }
    }
}
</style>



// WEBPACK FOOTER //
// StarredItemsWidget.vue?0cc35b64